import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { QuestionCircleFilled } from '@ant-design/icons';
import React from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Info = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { miniProgramPath, miniProgramAppId, qrCodeUrl } = props;
  return (
    <Section>
      <ItemWrapper
        title={
          <div>
            <span className={css.name}>
              {getI18n('general.miniProgramPath')}
            </span>
            <WhiteBackgroundTooltip
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n('general.miniProgramPath')}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n('general.miniProgramPathTip')}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled rev className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        }>
        {miniProgramPath || '-'}
      </ItemWrapper>

      <ItemWrapper
        title={
          <div>
            <span className={css.name}>
              {getI18n('general.miniProgramAppID')}
            </span>

            <WhiteBackgroundTooltip
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n('general.miniProgramAppID')}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n('general.miniProgramAppIDTip')}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled rev className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        }>
        {miniProgramAppId || '-'}
      </ItemWrapper>
      <ItemWrapper
        title={
          <div>
            <span className={css.name}>
              {getI18n('general.miniProgramQRCode')}
            </span>

            <WhiteBackgroundTooltip
              // visible
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n('general.miniProgramQRCode')}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n('general.miniProgramQRCodeTip')}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled rev className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        }>
        {qrCodeUrl ? (
          <a className={css.download} href={qrCodeUrl} download target='_blank'>
            {getI18n('general.download')}
          </a>
        ) : (
          '-'
        )}
      </ItemWrapper>
    </Section>
  );
};
export default Info;
